import { generatePath, useNavigate, useParams } from "react-router-dom";
import { useFetchExamples } from "~/api/storyblok/useFetchExamples";
import EmptyStateScreen from "~/components/organisms/EmptyStates/EmptyStateScreen";
import ExamplesGrid from "~/components/organisms/Examples/ExamplesGrid";
import ExamplesList from "~/components/organisms/Examples/ExamplesList";
import useTreatmentType from "~/hooks/useTreatmentType";
import { ExampleCategory } from "~/modules/example/example";
import { Routes } from "~/routes/routes";

const HairExamples = () => {
  const { data, isLoading, isError } = useFetchExamples(ExampleCategory.hair);
  const { getProductItemCategoryKeySelected } = useTreatmentType();
  const activeExamples = data?.filter((example) =>
    getProductItemCategoryKeySelected(example.categoryKey)
  );
  const navigate = useNavigate();
  const { opportunityId } = useParams();

  const goToHairConfiguration = () => {
    navigate(
      generatePath(Routes.HairConfiguration, {
        opportunityId: opportunityId as string,
      })
    );
  };

  return (
    <ExamplesList isLoading={isLoading} isError={isError}>
      {activeExamples?.length ? (
        <ExamplesGrid examples={activeExamples} />
      ) : (
        <EmptyStateScreen onClick={goToHairConfiguration} />
      )}
    </ExamplesList>
  );
};
export default HairExamples;
